import React from 'react';
import { Hyperlink } from '../../../../components/atoms/Hyperlink';
import { PersonInformationModifier } from '../../../../components/molecules/PersonInformation';
import { ISonURL } from '../../../../types/IUrl';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type ProfileLink = {
  profileLink: ISonURL;
  dfn: string;
  officeDenotation?: string;
  modifier?: Modifier<PersonInformationModifier> | undefined;
};

export function ProfileLink({ profileLink, dfn, modifier, officeDenotation }: ProfileLink) {
  const { t } = useSonTranslation('glossary');
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      <Hyperlink to={profileLink.url} className="personal-data__link">
        {modifier === PersonInformationModifier.TICKET
          ? (
              profileLink.name
            )
          : (
              <strong className="font-bold-15-19">{profileLink.name}</strong>
            )}
      </Hyperlink>
      {officeDenotation
        ? <>
            <dfn className="invisible">{t('officeDenotation')}:</dfn><span> ({officeDenotation})</span>
          </>
        : null}
    </p>
  );
}
